/* eslint-disable */
import React, { useState, useEffect, useCallback, useContext } from 'react';
import { useForm, Controller } from 'react-hook-form';
import {
  CircularProgress,
  TextField,
  Autocomplete,
  Box,
  Checkbox,
  Button,
  Typography,
} from '@mui/material';
import CommonTextField from '../../../Components/TextField/textField';
import CommonDatePicker from '../../../Components/Datepicker/datepicker';
import TimePicker from '../../../Components/TimePicker/timePicker';
import SearchDropdown from '../../../Components/Dropdown/dropdown';
import ProfilePicPlaceHolder from '../../../Assets/images/png/profil-pic-placeholder-large.png';
import { SIGNUP_TECH_SESSION } from '../../../Constants/strings';
import './signUpTechSession.scss';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import BACK_BUTTON from '../../../Assets/images/svg/dar_back_arrow.svg';
import { useNavigate } from 'react-router-dom';
import {
  fetchConferenceList,
  fetchDepartmentList,
  fetchVertivalList,
} from '../../SkillMap/apiCallUtil';
import { saveApprovalTechSessionData, getDepartmentList } from '../../../Api/request/techSessions';
import dayjs from 'dayjs';
import UseAxios from '../../../Api/http/http';
import debounce from 'lodash.debounce';
import { fetchUserDataFromZoho } from '../../../Utils/userDataUtil';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider';
import CloseIcon from '@mui/icons-material/Close';
import { STATUS_CODES } from '../../../Api/resources/statusCodes';
import { AuthContext } from '../../../Contexts/AuthContext';
import ApproveRejectForm from '../ApproveRejectTechSession/approveRejectForm';
import { IconButton } from '@mui/material';
import AddIcon from '../../../Assets/images/svg/dar_add_circle.svg';
import RemoveIcon from '../../../Assets/images/svg/dar_delete_parameter.svg';

const SignupTechSession = () => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    setError,
    clearErrors,
    watch,
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      hostName: null,
      sessionType: null,
      date: null,
      startTime: null,
      endTime: null,
      sessionName: '',
      topic: '',
      addHost: [],
      audience: [{ verticalId: null, departmentId: [] }],
      location: null,
      description: ''
    },
  });
  const redirectUrl = localStorage.getItem('redirectAfterLogin');
  let sessionIdInURL = null;
  if (redirectUrl) {
    const params = new URLSearchParams(new URL(redirectUrl).search);
    sessionIdInURL = parseInt(params.get('sessionId'), 10);
  }
  const urlSearchParams = new URLSearchParams(window.location.search);
  const sessionId = urlSearchParams.get('sessionId');

  if (sessionId || sessionIdInURL) {
    return <ApproveRejectForm sessionId={sessionId || sessionIdInURL} />;
  }
  const [hostName, setHostName] = useState([]);
  const [coHost, setCoHost] = useState([]);
  const [hostNameInputValue, setHostNameInputValue] = useState('');
  const [coHostInputValue, setCoHostInputValue] = useState('');
  const sessionTypeValue = watch('sessionType');
  const navigate = useNavigate();
  const [departmentList, setDepartmentList] = useState([]);
  const [verticalList, setVerticalList] = useState([]);
  const [confList, setConfList] = useState([]);
  const [loadingEmployeeList, setLoadingEmployeeList] = useState(false);
  const [autoCompleteOpen, setAutoCompleteOpen] = useState(false);
  const [loadingCoHostList, setLoadingCoHostList] = useState(false);
  const [autoCompleteCoHostOpen, setAutoCompleteCoHostOpen] = useState(false);
  const { snackbarOpen } = useSnackbar();
  const [locationError, setLocationError] = useState('');
  const { userProfile } = useContext(AuthContext);
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);
  const [wasSaved, setWasSaved] = useState(false);
  const [departmentsByVertical, setDepartmentsByVertical] = useState({});
  const [loadingDepartments, setLoadingDepartments] = useState({});

  const formValues = watch();

  useEffect(() => {
    if (wasSaved) {
      setIsSaveDisabled(false);
      setWasSaved(false);
    }
  }, [JSON.stringify(formValues)]);

  const handleInputChange = (event) => {
    const { id, value } = event.target;

    if (id === 'tech_session_session_type') {
      setValue('sessionType', value, { shouldValidate: true });
    } else if (id === 'tech_session_start_time') {
      setValue('startTime', value, { shouldValidate: true });
      validateTimes(value, watch('endTime'));
    } else if (id === 'tech_session_end_time') {
      setValue('endTime', value, { shouldValidate: true });
    }
  };

  const validateTimes = (startTime, endTime) => {
    if (startTime && endTime) {
      if (new Date(endTime) <= new Date(startTime)) {
        setError('endTime', { type: 'manual', message: 'End time must be after start time.' });
        return false;
      } else {
        clearErrors('endTime');
        return true;
      }
    }
    return true;
  };

  useEffect(() => {
    fetchVertivalList().then(setVerticalList);
    fetchConferenceList().then(setConfList);
  }, []);

  const fieldsToShow = [
    'employeeId',
    'fullName',
    'emailId',
    'employeestatus',
    'photoSignedUrl',
  ];

  const fetchDepartmentsForVertical = async (verticalId, index) => {
    if (departmentsByVertical[verticalId]) {
      return;
    }

    setLoadingDepartments(prev => ({ ...prev, [index]: true }));

    try {
      const response = await UseAxios(getDepartmentList(verticalId));
      const departmentMapping = response?.data?.data?.departmentMapping || [];

      const departments = departmentMapping.map(d => ({
        id: d.departmentId,
        name: d.departmentName,
        dlId: d.dlId,
      }));

      setDepartmentsByVertical(prev => ({
        ...prev,
        [verticalId]: departments
      }));
    } catch (error) {
      console.error('Error fetching departments:', error);
      setDepartmentsByVertical(prev => ({
        ...prev,
        [verticalId]: []
      }));
    } finally {
      setLoadingDepartments(prev => ({ ...prev, [index]: false }));
    }
  };

  const debouncedFetchUserInfo = useCallback(
    debounce(async (newInputValue, setEmpOptions) => {
      try {
        const employeeInfo = await fetchUserDataFromZoho(
          newInputValue,
          fieldsToShow,
        );
        setEmpOptions(employeeInfo);
        setLoadingEmployeeList(false);
        setLoadingCoHostList(false);
      } catch (error) {
        console.error("Failed to fetch user data", error);
        setLoadingEmployeeList(false);
        setEmpOptions([]);
        setLoadingCoHostList(false);
      }
    }, 500),
    []
  );

  const handleEmployeeNameChange = async (newInputValue) => {
    setHostNameInputValue(newInputValue);
    if (newInputValue && newInputValue.length >= 3) {
      setLoadingEmployeeList(true);
      setAutoCompleteOpen(false);
      debouncedFetchUserInfo(newInputValue, (data) => {
        setHostName(data);
        setAutoCompleteOpen(data.length > 0);
      });
    } else if (newInputValue === '') {
      setHostName([]);
      setLoadingEmployeeList(false);
      setAutoCompleteOpen(false);
    } else {
      setLoadingEmployeeList(false);
      setAutoCompleteOpen(false);
    }
  };

  const handleCoHostNameChange = async (newInputValue) => {
    setCoHostInputValue(newInputValue);
    if (newInputValue && newInputValue.length >= 3) {
      setLoadingCoHostList(true);
      setAutoCompleteCoHostOpen(false);
      debouncedFetchUserInfo(newInputValue, (data) => {
        setCoHost(data);
        setAutoCompleteCoHostOpen(data.length > 0);
      });
    } else if (newInputValue === '') {
      setCoHost([]);
      setLoadingCoHostList(false);
      setAutoCompleteCoHostOpen(false);
    } else {
      setLoadingCoHostList(false);
      setAutoCompleteCoHostOpen(false);
    }
  };

  // Helper to extract status and error message from response
  const extractStatusAndMessage = (response, defaultMsg) => {
    if (!response) return { status: undefined, errorMsg: defaultMsg };
    if (response.status) return { status: response.status, errorMsg: defaultMsg };
    if (response?.data?.isAxiosError) {
      return {
        status: response.data.response?.status,
        errorMsg: response.data.response?.data?.externalMessage || defaultMsg
      };
    }
    if (response?.data?.response?.status) {
      return {
        status: response.data.response.status,
        errorMsg: response.data.response.data?.externalMessage || defaultMsg
      };
    }
    return { status: undefined, errorMsg: defaultMsg };
  };

  const onSubmit = async (data) => {
    let hasError = false;

    if (!data.date) {
      setError('date', { type: 'manual', message: 'Please select a session date' });
      hasError = true;
    }
    if (!validateTimes(data.startTime, data.endTime)) {
      hasError = true;
    }

    if (sessionTypeValue?.name === 'In-Person' && (!data.location || !data.location.name)) {
      setLocationError('Location is not selelcted');
      hasError = true;
    } else {
      setLocationError('');
    }

    if (hasError) return;

    const deptVerDetails = (data.audience || [])
      .filter(row => row.verticalId)
      .map(row => ({
        verticalId: row.verticalId?.id,
        departmentId: row.departmentId?.map(d => d.id) || []
      }));

    const payload = {
      sessionName: data.sessionName,
      sessionTopic: data.topic,
      hostId: data.hostName ? [data.hostName.employeeId] : "",
      sessionDate: data.date
        ? dayjs(data.date).format('YYYY-MM-DD')
        : "",
      sessionStartTime: data.startTime
        ? dayjs(data.startTime).format('HH:mm:ss')
        : "",
      sessionEndTime: data.endTime
        ? dayjs(data.endTime).format('HH:mm:ss')
        : "",
      description: data.description || "",
      sessionType: sessionTypeValue?.name || "",
      location: sessionTypeValue?.name === 'In-Person'
        ? data.location?.name || ""
        : "",
      lastUpdatedBy: userProfile?.user_name,
      creatorId: userProfile?.employeeId,
      deptVerDetails,
    };

    if (Array.isArray(data.addHost) && data.addHost.length > 0) {
      payload.coHostId = data.addHost.map(c => c.employeeId);
    }

    const response = await sendPayload(payload);
    const { status, errorMsg } = extractStatusAndMessage(response, "Failed to set Tech session");
    if (status === STATUS_CODES.SUCCESS || status === 201) {
      snackbarOpen("Tech session set Successfully", 'success');
      setIsSaveDisabled(true);
      setWasSaved(false);
      reset({
        hostName: null,
        sessionType: null,
        date: null,
        startTime: null,
        endTime: null,
        sessionName: '',
        topic: '',
        addHost: [],
        audience: [{ verticalId: null, departmentId: [] }],
        location: null,
        description: ''
      });
      setHostNameInputValue('');
      setLocationError('');
      setTimeout(() => setWasSaved(true), 0);
    } else if (status === STATUS_CODES.INVALID_REQUEST) {
      snackbarOpen(errorMsg || "Conference room is already booked on this time slot", 'error');
    } else {
      snackbarOpen(errorMsg, 'error');
    }
  };

  const sendPayload = async (payload) => {
    try {
      const response = await UseAxios(saveApprovalTechSessionData(payload));
      return response;
    } catch (error) {
      console.error('Error:', error);
    }
  };


  return (
    <div className="deal-transition-master-outer-layer-a">
      <div className="deal-transition-master-map-title">
        <button
          type="button"
          className="deal-transition-master-back-button"
          onClick={() => {
            navigate('/tech-session/calendar');
          }}
        >
          <img src={BACK_BUTTON} alt="back icon" className='back-icon' />
        </button>
        {SIGNUP_TECH_SESSION.TITLE}</div>
      <div className="sign-up-tech-session-form">
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <div>
            <label className="sign-up-tech-session-label">{SIGNUP_TECH_SESSION.FIELDS.HOST_NAME}</label>
            <Controller
              name="hostName"
              control={control}
              rules={{ required: 'Please select a host.' }}
              render={({ field, fieldState }) => {
                const optionsWithSelected = React.useMemo(() => {
                  if (!field.value) return hostName;
                  const exists = hostName.some(
                    (opt) => opt.employeeId === field.value.employeeId
                  );
                  return exists
                    ? hostName
                    : field.value
                      ? [field.value, ...hostName]
                      : hostName;
                }, [hostName, field.value]);
                return (
                  <Autocomplete
                    open={autoCompleteOpen && hostName.length > 0}
                    onOpen={() => {
                      if (
                        hostNameInputValue &&
                        hostNameInputValue.length >= 3 &&
                        hostName.length > 0
                      ) {
                        setAutoCompleteOpen(true);
                      }
                    }}
                    onClose={() => setAutoCompleteOpen(false)}
                    id="tech_session_host"
                    options={optionsWithSelected}
                    value={field.value}
                    inputValue={hostNameInputValue}
                    onInputChange={(_event_, newValue, reason) => {
                      if (reason === 'input' || reason === 'clear') {
                        setHostNameInputValue(newValue);
                        handleEmployeeNameChange(newValue);
                      }
                    }}
                    onChange={(_event_, newValue, _reason) => {
                      field.onChange(newValue);
                      setHostNameInputValue(
                        newValue ? newValue.fullName : ''
                      );
                      setAutoCompleteOpen(false);
                    }}
                    getOptionLabel={(option) => option.fullName}
                    isOptionEqualToValue={(option, value) =>
                      option.employeeId === value.employeeId
                    }
                    loading={loadingEmployeeList}
                    loadingText={
                      <div className="sign-up-tech-session-loading">
                        <CircularProgress size={24} />
                      </div>
                    }
                    renderOption={(props, option, { selected }) => (
                      <Box
                        component="li"
                        {...props}
                        className={`option-with-checkbox host-option${selected ? ' host-option-selected' : ''}`}
                      >
                        <Box
                          component="img"
                          src={option.photoSignedUrl || ProfilePicPlaceHolder}
                          alt="Profile"
                          className="profile-image-host"
                        />
                        <Box
                          component="span"
                          className="host-option-label"
                        >
                          {`${option.fullName} · ${option.employeeId}`}
                        </Box>
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Enter name"
                        variant="outlined"
                        fullWidth
                        size='small'
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: params.InputProps.endAdornment,
                          className: 'custom-placeholder-style'
                        }}
                        error={!!errors.hostName}
                        helperText={errors.hostName?.message}

                      />
                    )}
                  />
                );
              }}
            />
          </div>
          <label className="sign-up-tech-session-label-other">{SIGNUP_TECH_SESSION.FIELDS.SESSION_NAME}</label>
          <Box className="sign-up-tech-session-input-field">
            <Controller
              name="sessionName"
              control={control}
              rules={{ required: 'Session name is required' }}
              render={({ field, fieldState }) => (
                <CommonTextField
                  {...field}
                  placeholder={SIGNUP_TECH_SESSION.PLACEHOLDER.SESSION_NAME}
                  variant="outlined"
                  size="small"
                  id="tech_sessios_name"
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </Box>

          <label className="sign-up-tech-session-label-other">{SIGNUP_TECH_SESSION.FIELDS.TOPIC}</label>
          <Box className="sign-up-tech-session-input-field">
            <Controller
              name="topic"
              control={control}
              rules={{ required: 'Topic is required' }}
              render={({ field, fieldState }) => (
                <CommonTextField
                  {...field}
                  placeholder={SIGNUP_TECH_SESSION.PLACEHOLDER.TOPIC}
                  variant="outlined"
                  size="small"
                  id="tech_session_topic"
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </Box>


          <label className="sign-up-tech-session-label-other" style={{ marginBottom: '4px' }}>{SIGNUP_TECH_SESSION.FIELDS.ADD_HOST}</label>
          <Controller
            name="addHost"
            control={control}
            render={({ field }) => (
              <Autocomplete
                open={autoCompleteCoHostOpen && coHost.length > 0}
                onOpen={() => {
                  if (coHostInputValue && coHostInputValue.length >= 3 && coHost.length > 0) {
                    setAutoCompleteCoHostOpen(true);
                  }
                }}
                onClose={() => setAutoCompleteCoHostOpen(false)}
                multiple
                disableCloseOnSelect
                popupIcon={null}
                id="tech_session_host"
                options={coHost}
                value={field.value}
                inputValue={coHostInputValue}
                onInputChange={(_event_, newValue, reason) => {
                  if (reason === 'input' || reason === 'clear') {
                    setCoHostInputValue(newValue);
                    handleCoHostNameChange(newValue);
                  }
                }}
                onChange={(_event_, newValue, _reason) => {
                  field.onChange(newValue);
                  setCoHostInputValue('');
                  setAutoCompleteCoHostOpen(false);
                }}
                getOptionLabel={(option) => option.fullName}
                isOptionEqualToValue={(option, value) => option.employeeId === value.employeeId}
                loading={loadingCoHostList}
                loadingText={
                  <div className="sign-up-tech-session-loading">
                    <CircularProgress size={24} />
                  </div>
                }
                renderOption={(props, option, { selected }) => (
                  <Box
                    component="li"
                    {...props}
                    className={`option-with-checkbox cohost-option${selected ? ' cohost-option-selected' : ''}`}
                  >
                    <Checkbox
                      checked={selected}
                      className="cohost-checkbox"
                    />
                    <Box
                      component="img"
                      src={option.photoSignedUrl || ProfilePicPlaceHolder}
                      alt="Profile"
                      className="profile-image-cohost"
                    />
                    <Box
                      component="span"
                      className="cohost-option-label"
                    >
                      {`${option.fullName} · ${option.employeeId}`}
                    </Box>
                  </Box>
                )}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Box
                      key={option.employeeId}
                      component="span"
                      className="cohost-tag"
                    >
                      <Box
                        component="span"
                        className="cohost-tag-label"
                      >
                        {option.fullName}
                      </Box>
                      <CloseIcon
                        fontSize="small"
                        className="cohost-tag-close"
                        onClick={(e) => {
                          e.stopPropagation();
                          const newValue = value.filter((_, i) => i !== index);
                          getTagProps({ index }).onDelete();
                        }}
                      />
                    </Box>
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Enter name"
                    className='custom-placeholder-style'
                    variant="outlined"
                    size='small'
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: params.InputProps.endAdornment,
                    }}
                  />
                )}
              />
            )}
          />

          <label className="sign-up-tech-session-label-other" style={{ marginBottom: '-5px' }}>{SIGNUP_TECH_SESSION.FIELDS.SESSION_DATE}</label>
          <Box flex={1} className={'sign-up-tech-session-date-picker'}>
            <Controller
              name="date"
              control={control}
              rules={{
                required: 'Please select a session date',
                validate: value => {
                  if (!value) return 'Please select a session date';
                  if (!dayjs(value).isValid()) return 'Invalid date format';
                  return true;
                }
              }}
              render={({ field, fieldState }) => (
                <div className="sign-up-session-date-container">
                  <CommonDatePicker
                    placeholder={SIGNUP_TECH_SESSION.PLACEHOLDER.SESSION_DATE}
                    value={field.value}
                    onChange={field.onChange}
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                    displayFormat="DD MMM,YYYY"
                  />
                  {fieldState.error && (
                    <p className="error-text">{fieldState.error.message}</p>
                  )}
                </div>
              )}
            />
          </Box>
          <label className="sign-up-tech-session-label-other" style={{ marginBottom: '2px' }}>{SIGNUP_TECH_SESSION.FIELDS.START_TIME}</label>
          <Box display="flex" gap="16px" className="sign-up-tech-session-time-slots">
            <Box flex={1} className={'sign-up-tech-session-time-picker'}>
              <Controller
                name="startTime"
                control={control}
                rules={{ required: 'Start time is required' }}
                render={({ field, fieldState }) => (
                  <TimePicker
                    placeHolder={SIGNUP_TECH_SESSION.PLACEHOLDER.START_TIME}
                    value={field.value}
                    onChange={(value) => {
                      field.onChange(value);
                      handleInputChange({
                        target: {
                          id: 'tech_session_start_time',
                          value: value
                        }
                      });
                    }}
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                  />
                )}
              />
            </Box>
            <Box flex={1} className={'sign-up-tech-session-time-picker'}>
              <Controller
                name="endTime"
                control={control}
                rules={{
                  required: 'End time is required',
                  validate: value => {
                    const startTime = watch('startTime');
                    return validateTimes(startTime, value) || 'End time must be after start time.';
                  }
                }}
                render={({ field, fieldState }) => (
                  <>
                    <TimePicker
                      placeHolder={SIGNUP_TECH_SESSION.PLACEHOLDER.END_TIME}
                      value={field.value}
                      onChange={(value) => {
                        field.onChange(value);
                        handleInputChange({
                          target: {
                            id: 'tech_session_end_time',
                            value: value
                          }
                        });
                      }}
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                    />
                  </>
                )}
              />
            </Box>
          </Box>


          <label className="sign-up-tech-session-label-other" >{SIGNUP_TECH_SESSION.FIELDS.SELECT_AUDIENCE}</label>
          <Controller
            name="audience"
            control={control}
            defaultValue={[{ verticalId: [], departmentId: [] }]}
            rules={{
              validate: (rows) => {
                if (!rows || rows.length === 0) return 'Please select an audience';
                const hasAtLeastOneVertical = rows.some(
                  (row) => row.verticalId !== null
                );

                if (!hasAtLeastOneVertical) {
                  return 'Please select at least one vertical';
                }
                return true;
              },
            }}
            render={({ field, fieldState: { error } }) => {
              const { value, onChange } = field;

              const handleAddRow = () => {
                onChange([...value, { verticalId: null, departmentId: [] }]);
              };

              const handleRemoveRow = (index) => {
                const updated = value.filter((_, i) => i !== index);
                onChange(updated);
              };

              const handleChange = (index, key, newValue) => {
                const updated = [...value];
                updated[index][key] = newValue;
                onChange(updated);
              };

              return (
                <>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px', marginTop: '-15px' }} className="audience-header-container">
                    <span></span>
                    <button
                      type="button"
                      onClick={handleAddRow}
                      className="add-more-audience-btn"
                    >
                      + Add more
                    </button>
                  </div>

                  {(Array.isArray(value) ? value : []).map((row, index) => (
                    <Box
                      key={index}
                      className="sign-up-tech-session-audience-row"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        position: 'relative',
                        mb: 2,
                      }}
                    >
                      {/* Vertical Dropdown */}
                      <Box sx={{ flex: 1 }}>
                        <Autocomplete
                          popupIcon={<KeyboardArrowDownIcon className="audience-vertical-dropdown-icon" />}
                          disableClearable
                          options={verticalList.filter(
                            (option) =>
                              !value.some((row, i) => i !== index && row.verticalId?.id === option.id)
                          )}
                          value={row.verticalId || null}
                          onChange={(_event, newValue) => {
                            handleChange(index, 'departmentId', []);
                            handleChange(index, 'verticalId', newValue);

                            if (newValue?.id) {
                              fetchDepartmentsForVertical(newValue.id, index);
                            }
                          }}
                          getOptionLabel={(option) => option.name}
                          isOptionEqualToValue={(option, val) => option.id === val.id}
                          renderOption={(props, option, { selected }) => (
                            <Box component="li" {...props} className={`option-with-checkbox audience-vertical-option${selected ? ' audience-vertical-option-selected' : ''}`}>
                              <Box component="span" className="audience-vertical-option-label">{option.name}</Box>
                            </Box>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select vertical"
                              error={!!error && (!row.verticalId || row.verticalId.length === 0)}
                              size="small"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    <KeyboardArrowDownIcon
                                      className="audience-vertical-dropdown-icon"
                                    />
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                              className="audience-autocomplete"
                            />
                          )}
                          className="audience-vertical-autocomplete"
                        />
                      </Box>

                      {/* Department Dropdown */}
                      <Box sx={{ flex: 1 }} className="audience-department-dropdown-container">
                        <Autocomplete
                          multiple
                          disableCloseOnSelect
                          popupIcon={<KeyboardArrowDownIcon className="audience-vertical-dropdown-icon" />}
                          options={departmentsByVertical[row.verticalId?.id] || []}
                          value={row.departmentId}
                          disabled={!row.verticalId}
                          onChange={(_event, newValue) =>
                            handleChange(index, 'departmentId', newValue)
                          }
                          getOptionLabel={(option) => option.name}
                          isOptionEqualToValue={(option, val) => option.id === val.id}
                          renderOption={(props, option, { selected }) => (
                            <Box component="li" {...props} className={`option-with-checkbox audience-vertical-option${selected ? ' audience-vertical-option-selected' : ''}`}>
                              <Checkbox checked={selected} className="audience-vertical-checkbox" />
                              <Box component="span" className="audience-vertical-option-label">{option.name}</Box>
                            </Box>
                          )}
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                              <Box key={option.id} component="span" className="audience-vertical-tag">
                                <Box component="span" className="audience-vertical-tag-label">{option.name}</Box>
                                <CloseIcon fontSize="small" className="audience-vertical-close-icon" onClick={e => { e.stopPropagation(); getTagProps({ index }).onDelete(); }} />
                              </Box>
                            ))
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder={SIGNUP_TECH_SESSION.PLACEHOLDER.SELECT_DEPARTMENT}
                              error={!!error}
                              disabled={!row.verticalId}
                              size="small"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    <KeyboardArrowDownIcon className="audience-vertical-dropdown-icon" />
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                              className="audience-department-autocomplete"  
                            />
                          )}
                          className="audience-vertical-autocomplete"
                        />
                      </Box>

                      {index > 0 && (
                        <IconButton
                          color="error"
                          onClick={() => handleRemoveRow(index)}
                          sx={{ position: 'absolute', right: -48 }}
                        >
                          <img src={RemoveIcon} alt="Remove" style={{ width: 24, height: 24 }} />
                        </IconButton>
                      )}
                    </Box>
                  ))}

                  <div className="audience-selection-note">
                    <Typography variant="body2">
                      <span className="note-label">Note:</span> Selecting department is optional. If no department is selected, the notification will be sent to the entire vertical distribution list by default.
                    </Typography>
                  </div>

                  {!!error && (
                    <Box sx={{ mt: '2px', ml: '2px' }}>
                      <p className="error-text">{error.message}</p>
                    </Box>
                  )}
                </>
              );
            }}
          />

          <Controller
            name="sessionType"
            control={control}
            rules={{ required: 'Session type is required' }}
            render={({ field }) => (
              <>
                <label className="sign-up-tech-session-label-other" style={{ marginBottom: '-20px' }}>{SIGNUP_TECH_SESSION.FIELDS.SESSION_TYPE}</label>
                <Box>
                  <SearchDropdown
                    options={[
                      { id: 1, name: 'In-Person' },
                      { id: 2, name: 'Virtual' },
                    ]}
                    searchBox={false}
                    placeholder={SIGNUP_TECH_SESSION.PLACEHOLDER.SESSION_TYPE}
                    value={sessionTypeValue}
                    onChange={(event) =>
                      handleInputChange({
                        target: {
                          id: 'tech_session_session_type',
                          value: event.target.value,
                        },
                      })
                    }
                    id="tech_session_session_type"
                  />
                  {errors.sessionType && (
                    <p className="error-text">{errors.sessionType.message}</p>
                  )}
                </Box>

                {sessionTypeValue?.name === 'In-Person' && (
                  <Box>
                    <label className="sign-up-tech-session-label-other" style={{ marginBottom: '-20px' }}>
                      {SIGNUP_TECH_SESSION.FIELDS.LOCATION}
                    </label>
                    <Controller
                      name="location"
                      control={control}
                      render={({ field }) => (
                        <>
                          <SearchDropdown
                            options={confList}
                            searchBox={false}
                            placeholder={SIGNUP_TECH_SESSION.PLACEHOLDER.LOCATION}
                            value={field.value || ''}
                            onChange={(event) => {
                              field.onChange(event.target.value);
                              setLocationError('');
                            }}
                            id="tech_session_location"
                          />
                          {locationError && (
                            <p className="error-text">{locationError}</p>
                          )}
                        </>
                      )}
                    />
                  </Box>
                )}
              </>
            )}
          />
          <label className="sign-up-tech-session-label-other">{SIGNUP_TECH_SESSION.FIELDS.DESCRIPTION}</label>
          <Controller
            name="description"
            control={control}
            render={({ field }) => (
              <CommonTextField
                {...field}
                placeholder={SIGNUP_TECH_SESSION.PLACEHOLDER.DESCRIPTION}
                variant="outlined"
                size="small"
                id="tech_session_description"
                multiline
                rows={2}
              />
            )} />
          <Box className="sign-up-submit-btn-row">
            <Button
              type="submit"
              variant="contained"
              onClick={handleSubmit((data) => onSubmit(data))}
              className="sign-up-submit-button"
              disabled={isSaveDisabled}
            >
              Save
            </Button>
          </Box>
        </form>
      </div>
    </div>
  );
};

export default SignupTechSession;
